import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Tag } from 'ngx-web-api';
import { Theme } from '../../domain/theme.model';
import { TagFilteringStyle } from '../../domain/tag-filtering-style.enum';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';

@Component({
  selector: 'fts-filtering-tags',
  templateUrl: './filtering-tags.component.html',
  styleUrls: ['./filtering-tags.component.scss'],
})
export class FilteringTagsComponent implements OnChanges {
  @Input()
  tags: Tag[];
  @Input()
  selectedTags: string[];
  @Input()
  theme: Theme;
  @Input()
  isInTitle = false;
  @Input()
  isIngredientTagList = false;

  @Output()
  tagClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  clearTags: EventEmitter<void> = new EventEmitter<void>();

  hasSelectedTags = false;
  isTagSelected: { [tag: string]: boolean };
  tagFilteringStyle = TagFilteringStyle;
  faCheck = faCheck;
  faTimes = faTimes;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedTags']) {
      if (this.tags) {
        this.isTagSelected = this.tags.reduce((prev, curr) => {
          const isSelected = !!this.selectedTags.find(t => curr.name === t);
          return { [curr.name]: isSelected, ...prev };
        }, {});
        this.hasSelectedTags = Object.values(this.isTagSelected).reduce((prev, curr) => prev || curr, false);
      }
    }
  }

  trackTag(index: number, tag: any) {
    return tag.name;
  }
}
